export type Period = 'today' | 'yesterday' | 'wtd' | 'mtd';

export const PERIODS: Period[] = ['today', 'yesterday', 'wtd', 'mtd'];

export const PERIOD_LABELS: Record<Period, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  wtd: 'WTD',
  mtd: 'MTD',
};

export const PERIOD_OPTIONS = PERIODS.map((value) => ({ value, label: PERIOD_LABELS[value] }));

/** Two periods shown together, in reading order: Today | WTD and WTD | MTD. */
export const orderPair = (period: Period, compare: Period): [Period, Period] =>
  period === 'mtd' ? [compare, period] : [period, compare];

/** "WTD + MTD" / "Today + WTD" label for a (period, compare_period) pair. */
export const pairLabel = (period: Period, compare: Period): string => {
  const [a, b] = orderPair(period, compare);
  return `${PERIOD_LABELS[a]} + ${PERIOD_LABELS[b]}`;
};
